import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PaisService } from '../shared/pais/pais.service';
import { MdcService } from '../shared/mdc/mdc.service';
import { NgForm } from '@angular/forms';
import { LocalizacaoService } from '../shared/localizacao/localizacao.service';
import { InqueritoService } from '../shared/inquerito/inquerito.service';
import { AuthService } from '../shared/auth/auth.service';
import { LanguageService } from '../shared/language/language.service';
import { Mdc } from '../shared/mdc/mdc.model';
import { Capacitor } from '@capacitor/core';
import { SqlliteDbService } from '../shared/sqlite/sqllite-db.service';

declare var NioApp: any, Swal: any;

@Component({
  selector: 'app-mdc-form',
  templateUrl: './mdc-form.component.html',
})
export class MdcFormComponent implements OnInit, AfterViewInit {

  isSubmitting = false;
  isVisivel = false;
  syncStatus = {
    pending: 0,
    lastSync: null as Date | null
  };

  constructor(public paisService: PaisService,
    public mdcService: MdcService,
    public locService: LocalizacaoService,
    private inqueritoService: InqueritoService,
    public authService: AuthService,
    public languageService: LanguageService,
    private sqliteService: SqlliteDbService
  ) { }

  onSubmit(form: NgForm) {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.inqueritoService.getValidateData().subscribe({
      next: (result) => {
        if (result) {
          if (form.valid) {
            if (this.authService.isAuthenticated()) {
              this.mdcService.postMdcAuto();
            } else {
              this.mdcService.postMdc();
            }
          }
        } else {
          var erro_msg = this.languageService.getDateTranslation('dateEndAlert');
          Swal.fire({ title: 'Aviso!', text: erro_msg, icon: 'warning', });
        }
      },
      error: () => {
        this.isSubmitting = false;
        var erro_msg = this.languageService.getDateTranslation('error_occurred');
        Swal.fire({ title: 'Erro!', text: erro_msg, icon: 'error', });
      },
      complete: () => {
        this.isSubmitting = false;
      },
    });
  }

  async onSubmitOffline() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    if (!this.authService.isAuthenticated()) {
      return;
    }
    try {
      if (Capacitor.getPlatform() !== 'web') {
        const email = this.authService.getEmail();
        if (email != null) {
          const saved = await this.sqliteService.salvarQuestionario(this.mdcService.formData, email);
          if (saved) {
            Swal.fire({ title: 'Aviso!', text: 'Questionário salvo localmente com sucesso!', icon: 'success', });
            this.mdcService.formData = new Mdc();
            this.mdcService.removeLocalStorageFormData();
            this.updateSyncStatus();
            window.location.reload();
          } else {
            this.isSubmitting = false;
            Swal.fire({ title: 'Aviso!', text: 'Erro ao salvar questionário.', icon: 'warning', });
          }
        }
      } else {
        console.warn('SQLite não está disponível no navegador.');
        this.mdcService.addToLocalStorageList()
      }
    } catch (error) {
      this.isSubmitting = false;
      Swal.fire({ title: 'Aviso!', text: 'Erro ao salvar questionário.', icon: 'warning', });
    }
  }

  async ngOnInit() {
    // Inicializa componetes do formulário
    this.mdcService.loadForm();

    // Inicializa o serviço SQLite
    if (Capacitor.getPlatform() !== 'web') {
       this.isVisivel = true;
      await this.sqliteService.initializeOpenConnection();
    }
    //await this.sqliteService.initializePlugin();
    // Atualiza o status de sincronização
    this.updateSyncStatus();
  }

  ngAfterViewInit(): void {
    NioApp.Stepper.init();
  }

  private async updateSyncStatus() {
    this.syncStatus.pending = await this.sqliteService.getTotalPendentes();
    this.syncStatus.lastSync = new Date();
  }
}
